// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","viewsList":"_32KOcq_Ah5GCG7v5jSde-H","viewElement":"_3aCg7gLZQSJt-4oLzpYflC"};